<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card card-rounded">
                    <div class="card-header">
                        <div class="container">
                            <div class="row">
                                <div class="col-md">
                                    <div class="form-group">
                                        <label>{{ transEdit('companies') }}</label>
                                        <multiselect
                                            v-model="selectedCompanies"
                                            :options="companies"
                                            track-by="name"
                                            label="name"
                                            :showLabels="false"
                                            :hideSelected="true"
                                            placeholder="Välj företag"
                                            selectLabel=""
                                            deselectLabel=""
                                            :multiple="true">
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="col-md">
                                    <div class="form-group ">
                                        <label>{{ transEdit('therapists') }}</label>
                                        <multiselect
                                            v-model="selectedTherapists"
                                            :options="filterTherapists"
                                            track-by="name"
                                            label="name"
                                            :showLabels="false"
                                            :hideSelected="true"
                                            placeholder="Välj terapeut"
                                            selectLabel=""
                                            deselectLabel=""
                                            :multiple="true">
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="col-md">
                                    <div class="form-group ">
                                        <label>{{ transEdit('city') }}</label>
                                        <multiselect
                                            v-model="selectedCities"
                                            :options="filterCities"
                                            track-by="name"
                                            label="name"
                                            :showLabels="false"
                                            :hideSelected="true"
                                            placeholder="Välj stad/ort"
                                            selectLabel=""
                                            deselectLabel=""
                                            :multiple="true">
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="row d-flex justify-content-around">
                                <div class="d-flex justify-content-around">
                                    <div class="calendar-container">
                                        <calendar
                                            :dark-header="true"
                                            :initialDate="currentlyActiveDate"
                                            :ajax-url="calendarUrl"
                                            @daySelected="daySelected"
                                            @monthChanged="getLocks"
                                            ref="calendar"
                                            date-key="date"
                                            :noColorCoding="true"
                                            :showWeekNumber="true"
                                        ></calendar>
                                    </div>
                                </div>
                            </div>
                            <div v-if="isLocked" class="text-center text-danger">
                                <i class="fa fa-lock"></i> {{ transEdit('Månaden är låst') }}
                            </div>
                            <div class="row">
                                <flash></flash>
                                <batches-panel
                                    :route_refresh="get_batches_route"
                                    :initialBatch="parsedInitialBatch"
                                    :batches="currentBatches"
                                    :currentDate="currentlyActiveDate"
                                    ref="batchpanel"
                                    @selected="batchSelected"
                                ></batches-panel>
                            </div>
                        </div>
                    </div>
                    <div class="card-body" v-if="currentlyActiveBatch">
                        <admin-schedules-list
                            :batch="currentlyActiveBatch"
                            :date="currentlyActiveDate"
                            :filter_events_route="filter_events_route"
                            ref="schedulelist"
                            @bookModal="showBookModal"
                            @deleteSchedule="showDeleteScheduleModal"
                        ></admin-schedules-list>
                    </div>
                    <admin-schedules-modal-unbook v-on:refresh="doRefresh"></admin-schedules-modal-unbook>
                    <admin-schedules-modal-unbook-day v-on:refresh="doRefresh"></admin-schedules-modal-unbook-day>
                    <admin-schedules-modal-customer-absent :route_absent="route_absent" v-on:refresh="doRefresh"></admin-schedules-modal-customer-absent>
                    <admin-schedules-modal-customer-present :route_present="route_absent" v-on:refresh="doRefresh"></admin-schedules-modal-customer-present>
                    <admin-schedules-modal-remove-day :route_delete_day="route_delete_day" v-on:refresh="scheduleRemoved"></admin-schedules-modal-remove-day>
                    <admin-schedules-modal-add-schedule v-on:refresh="doRefresh"></admin-schedules-modal-add-schedule>
                    <admin-schedules-modal-delete-schedule :schedule="scheduletobedeleted" :route_delete_schedule="route_delete_schedule" v-on:refresh="doRefresh"></admin-schedules-modal-delete-schedule>
                    <admin-schedules-modal-book v-on:refresh="doRefresh" :schedule="bookSchedule"></admin-schedules-modal-book>
                    <admin-schedules-batch-modal-change-location v-on:refresh="doRefresh"></admin-schedules-batch-modal-change-location>
                    <admin-schedules-batch-modal-change-therapist v-on:refresh="doRefresh"></admin-schedules-batch-modal-change-therapist>

                    <admin-schedules-batch-modal-change-therapist></admin-schedules-batch-modal-change-therapist>
                    <admin-schedules-batch-modal-change-period v-on:refresh="doRefresh"></admin-schedules-batch-modal-change-period>
                    <admin-schedules-batch-modal-change-weekdays v-on:refresh="doRefresh"></admin-schedules-batch-modal-change-weekdays>
                    <admin-schedules-modal-absence v-on:refresh="doRefresh"></admin-schedules-modal-absence>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BatchesPanel from "./BatchesPanel";
import BatchesCalendar from "./BatchesCalendar";
import AdminSchedulesCalendar from "./AdminSchedulesCalendar";
import AdminSchedulesList from "./AdminSchedulesList";
import AdminSchedulesModalUnbook from "./AdminSchedulesModalUnbook";
import AdminSchedulesModalUnbookDay from "./AdminSchedulesModalUnbookDay.vue";
import axios from "axios";

export default {
    name: "adminSchedules",
    components: {
        BatchesCalendar,
        AdminSchedulesList,
        AdminSchedulesCalendar,
        BatchesPanel,
        AdminSchedulesModalUnbook,
        AdminSchedulesModalUnbookDay,
    },
    props: ['therapists', 'companies', 'treatments', 'user_id', 'cannot_book', 'company', 'locations', 'get_batches_route',
        'filter_events_route', 'get_schedules_for_batch', 'initial_date', 'initial_batch', 'therapists', 'route_absent',
        'route_delete_day', 'route_delete_schedule', 'cities'],
    data() {
        let parsedInitialBatch = false;
        if (this.initial_batch) {
            parsedInitialBatch = this.initial_batch;
        }
        return {
            canNullBatches: !this.initial_date,
            currentBatches: null,
            parsedInitialBatch: parsedInitialBatch,
            currentlyActiveBatch: parsedInitialBatch,
            currentlyActiveDate: this.initial_date ? moment(this.initial_date) : moment(),
            selectedSchedule: null,
            selectedLocations: [],
            selectedTherapists: [],
            selectedCompanies: [],
            selectedTreatments: [],
            selectedCities: [],
            scheduletobedeleted: {},
            showFilters: false,
            bookSchedule: null,
            days: ["Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag"],
            isLocked: false,
        }
    },
    computed: {
        filterTherapists() {
            let simplifiedTherapists = [];
            if (this.therapists) {
                this.therapists.forEach((therapist) => {
                    simplifiedTherapists.push({
                        id: therapist.id,
                        name: therapist.user ? therapist.user.name : 'OKÄND',
                    });
                });
            }
            return simplifiedTherapists;
        },

        filterCities() {
            let simplifiedCities = [];
            if (this.cities) {
                this.cities.forEach((city) => {
                    simplifiedCities.push({
                        id: city.id,
                        name: city.name,
                    });
                });
            }
            return simplifiedCities;
        },

        companyToUse() {
            if (this.currentlyActiveBatch) {
                return this.currentlyActiveBatch.location.primary_company;
            } else if (this.company) {
                return this.company;
            }

            return 1;
        },
        calendarUrl() {
            let url = this.get_batches_route;
            let first = true;
            let symbol = '?';
            this.selectedTherapists.forEach((therapist) => {
                url += symbol + 'therapist_ids[]=' + therapist.id;
                if (first) {
                    symbol = '&';
                    first = false;
                }
            });

            this.selectedCompanies.forEach((therapist) => {
                url += symbol + 'company_ids[]=' + therapist.id;
                if (first) {
                    symbol = '&';
                    first = false;
                }
            });

            this.selectedCities.forEach((city) => {
                url += symbol + 'city_ids[]=' + city.id;
                if (first) {
                    symbol = '&';
                    first = false;
                }
            });

            return url;
        }
    },
    methods: {
        doRefresh() {
            if(this.$refs.calendar) {
                this.$refs.calendar.ajaxEvents();
                this.$refs.calendar.dateClicked(this.currentlyActiveDate);
            }

            if(this.$refs.schedulelist) {
                this.$refs.schedulelist.getSchedules();
            }
        },
        scheduleRemoved() {
            this.doRefresh();
            this.$refs.calendar.ajaxEvents();
            this.$refs.calendar.dateClicked(this.currentlyActiveDate);
        },
        showBookModal: function (schedule) {
            this.bookSchedule = schedule;
            let bookModal = $("#book-modal");
            bookModal.modal("show");
        },
        showDeleteScheduleModal: function (schedule) {
            this.scheduletobedeleted = schedule;
            let deleteScheduleModal = $("#schedule-delete-modal");
            let deleteScheduleModalDate = $("#schedule-delete-modal-date");
            let deleteScheduleModalTime = $("#schedule-delete-modal-time");

            let time = new Date(schedule.start).getHrsMins() + " - " + new Date(schedule.end).getHrsMins();
            let date = new Date(schedule.start).getYMD();

            deleteScheduleModalDate.text(date);
            deleteScheduleModalTime.text(time);

            deleteScheduleModal.modal("show");
        },
        daySelected(message) {
            if (message instanceof moment) {
                this.currentlyActiveDate = message;
            } else {
                this.currentlyActiveDate = message.date;
            }

            this.currentBatches = message.events;

            if (this.$refs.schedulelist) {
                this.$refs.schedulelist.emptyList();
            }

            if (this.$refs.batchpanel && this.canNullBatches) {
                this.$refs.batchpanel.setActiveBatchToNull();
            }

            if (!this.canNullBatches) {
                this.canNullBatches = true;
                if (this.parsedInitialBatch) {
                    this.$refs.schedulelist.getSchedules();
                }
            }
        },
        batchSelected(message) {
            this.currentlyActiveBatch = message.batch;
        },
        setDate(date) {
            this.date = date;
        },
        getDay(date) {
            return new Date(date).getDay()
        },
        getDateTime(dateString) {
            return moment(dateString).format('YYYY-MM-DD HH:mm')
        },
        getTime(dateString) {
            return moment(dateString).format('HH:mm')
        },
        getLocks(event) {
            //event is a moment object, get the year and month
            let year = event.year();
            let month = event.month() +1;
            axios.get('/monthlyperiods/islocked/' + year + '/' + month).then((response) => {
                this.isLocked = response.data.is_locked;
            });
        }
    },
    mounted() {
        this.selectedCompanies = this.company && !Array.isArray(this.company) ? [this.company] : [];
        this.getLocks(moment());
    }
}
</script>
<style scoped>
.text-small {
    font-size: 0.6em;
}

.calendar-container {
    width: 500px;
    font-size: 0.8em;
}
</style>
